import { render } from "./LibraryContent.vue?vue&type=template&id=00f32349&scoped=true"
import script from "./LibraryContent.vue?vue&type=script&lang=js"
export * from "./LibraryContent.vue?vue&type=script&lang=js"

import "./LibraryContent.vue?vue&type=style&index=0&id=00f32349&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f32349"]])

export default __exports__